import React from 'react';
import { VenueList } from '../../components';
import s from './HostStyles.module.scss';
import venueData from './data/venue-list.json';

const VenueListEditor = () => (
    <div className={s.editor}>
        <VenueList venuesToRender={venueData} />
    </div>
);

export default VenueListEditor;
